import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

import Navigation from "@/features/dashboard/components/navigation/navigation";
import { WithAuthentication } from "@/features/shared/features/authentication";
import useLayoutStore from "@/store/useLayoutStore";

import styles from "./layout.module.css";

const RootLayout = () => {
  const [isFullscreen, layoutStore] = useLayoutStore((s) => s.context.isFullscreen);

  const location = useLocation();
  useEffect(() => {
    // exit fullscreen if location has changed
    layoutStore.trigger.setFullscreen({ value: false });
  }, [location]);

  // set scroll options when fullscreen is toggled
  useEffect(() => {
    document.body.style.overflow = isFullscreen ? "hidden" : "auto";
    window.scrollTo(0, 0);
    const resizeTimeout = setTimeout(() => {
      // force resize event for widget that need it
      window.dispatchEvent(new Event("resize"));
    }, 250);
    return () => clearTimeout(resizeTimeout);
  }, [isFullscreen]);

  return (
    <div className={styles.layout}>
      <Navigation />

      <div className={styles.content}>
        <Outlet />
      </div>
    </div>
  );
};

export default RootLayout;

export const AuthenticatedDashboardLayout = WithAuthentication(() => {
  return <RootLayout />;
});
